import React, {useEffect, useState} from "react";
import CustomContainer from "../../components/CustomContainer";
import Loader from "../../components/Loader";
import CardForm from "../../components/form/CardForm";
import {useHistory, useParams} from "react-router-dom";
import {Actions} from "../../../client/Actions";
import FontFillAllFormConfig from "./FontFillAllFormConfig";
import AddSymbolFormConfig from "./AddSymbolFornConfig";
import {MachineHeader} from "../format/MachineHeader";
import MachineSelectionSection from "../format/MachineSelectionSection";
import {LinkIconButton} from "../../components/button/LinkIconButton";
import models from "../../helpers/models";
import {Col} from "react-bootstrap";
import {hasFontManagementFullAccess} from "../../helpers/jwt";
import { useTranslation } from 'react-i18next';

const FontPage = (props) => {
    const { t } = useTranslation();
    let {machineId} = useParams();
    const history = useHistory();

    const [loader, setLoader] = useState(false);
    const [reload, setReload] = useState(false);
    const [machine, setMachine] = useState();
    const [fields, setFields] = useState();
    const [symbols, setSymbols] = useState();
    const [fonts, setFonts] = useState({});
    const [fillAllFonts, setFillAllFonts] = useState();
    const [configuredMachines, setConfiguredMachines] = useState();


    function loadMachine() {
        if (machineId) {
            setLoader(true)
            Actions.get("machine/" + machineId, machineLoaded)
            Actions.get("font/" + machineId, fontsLoaded)
        } else {
            Actions.get("font/machines", configuredMachinesLoaded)

        }
    }

    function configuredMachinesLoaded(data) {
        setConfiguredMachines(data.filter(m => m.exists).map(conf => conf.machine.id))
    }

    function machineLoaded(data) {
        setMachine(data)
    }

    function fontsLoaded(data) {
        const result = data.map((value, i) => {
            return {
                name: "font_field_" + i,
                label: value.name,
                defaultValue: value.minimalQuantity,
                type: "number",
                column: i + 1 > columns ? (i % columns) + 1 : i + 1
            }
        })

        setFields(result)
        setLoader(false)
    }


    function onSaved() {
        setLoader(false)
        history.push("font/" + machine.id)
    }

    function save() {
        const dto = {
            machine: {id: machine.id},
            fonts: Object.keys(fonts).filter(k => fields.some(f => f.name === k)).map(k => {
                return {
                    name: fields.find(f => f.name === k).label,
                    minimalQuantity: fonts[k]
                }
            })
        }

        Actions.post("font", dto, onSaved)
    }


    // Generating A-Z dynamically
    const alphabetArray = Array.from({length: 26}, (v, i) => String.fromCharCode(65 + i)).map(n => n + ""); // ['A', 'B', ..., 'Z']

    // Generating 1-9 dynamically
    const numberArray = Array.from({length: 9}, (v, i) => i + 1).map(n => n + ""); // [1, 2, 3, 4, 5, 6, 7, 8, 9]

    const columns = 6

    const generateSymbols = () => {
        console.log("generate symbols")
        setSymbols(alphabetArray.concat(numberArray))
    }

    function generateColumns() {
        console.log("generate columns")
        if (!machineId && symbols) {
            const result = symbols.map((value, i) => {
                return {
                    name: "font_field_" + i,
                    label: value,
                    type: "number",
                    column: i + 1 > columns ? (i % columns) + 1 : i + 1,
                    removable: true,
                    mandatory: true,
                    removableTooltip: t("common.delete")
                }
            })

            setFields(result)
        }
    }

    useEffect(loadMachine, [machineId])
    useEffect(generateColumns, [machine, symbols])
    useEffect(generateSymbols, [])

    return (
        <>
            <Loader loader={loader}/>

            <CustomContainer
                title={machineId ? t("object_types.font") : t("menu.font_management")}
                
                parent={
                    <LinkIconButton
                        model={models.font}
                        props={props}
                    />
                }
                subtitle={
                    <>

                    </>
                }>

                {!machineId && !machine &&
                    <Col md={6}>
                        <MachineSelectionSection
                            setSelectedMachine={setMachine}
                            setLoader={setLoader}
                            notIn={configuredMachines}
                            access={hasFontManagementFullAccess()}
                            onSaved={() => {
                            }}
                        />
                    </Col>
                }
                {machine &&
                    <MachineHeader
                        machine={machine}
                        packingLineName={machine.packingLineName}
                    />
                }
                {machine &&
                    <>
                        {!machineId &&
                            <>
                                <CardForm
                                    withoutHeader={true}
                                    setLoader={setLoader}
                                    fields={FontFillAllFormConfig}
                                    width={3}
                                    withoutCancel={true}
                                    saveButton={t("common.fill")}
                                    disableLoader={true}
                                    customSave={(data) => {
                                        const tmp = {}
                                        fields.forEach(f => tmp[f.name] = data.value)

                                        setFillAllFonts(tmp)
                                    }}
                                />
                                <CardForm
                                    withoutHeader={true}
                                    setLoader={setLoader}
                                    fields={AddSymbolFormConfig}
                                    width={3}
                                    saveButton={t("common.add")}
                                    withoutCancel={true}
                                    disableLoader={true}
                                    customSave={(data, onSaved) => {
                                        setSymbols(prevSymbols => {
                                            return [...prevSymbols, data.value];
                                        });
                                        onSaved();
                                    }}
                                />
                            </>
                        }
                        {fields &&
                            <CardForm
                                title={t("common.minimal_states")}
                                setLoader={setLoader}
                                replaceFormData={fillAllFonts}
                                fields={{
                                    config: {columns: columns},
                                    fields: fields
                                }}
                                width={12}
                                readOnly={!!machineId}
                                onRemoveField={(f) => {
                                    setSymbols(prevSymbols => {
                                        return prevSymbols.filter(symbol => symbol !== f.label);
                                    });
                                }}
                                postSaved={() => {
                                    setReload(!reload)
                                }}
                                postCancel={() => {
                                }}
                                formDataChanged={(data) => setFonts(data)}
                                customSave={save}
                            />
                        }
                    </>
                }


            </CustomContainer>
        </>
    );
};

export default FontPage;
